import { forEach, get, isEmpty } from 'lodash';
import * as React from 'react';
import { IMtaState } from '../../../../../../../../services/mta/models';
import { ICustomerMTAOptions } from '../../../../index';
import { MTAChangeDetails } from '../MTAChangeDetails';

interface IMTARemoveOptionProps {
  mta: IMtaState,
  customerMTAOptions: ICustomerMTAOptions,
  handleSelection: any
}

export const MTARemoveOption = ({ mta, customerMTAOptions, handleSelection }: IMTARemoveOptionProps) => {

  const selectedPolicyOptions = get(mta, 'selectedPolicy.metadata.options', [])
  const addedOptions = {};
  forEach(selectedPolicyOptions, (value, key) => {
    if (key === 'hazardous_activities') {
      return;
    }
    if (value) {
      addedOptions[key] = value;
    }
  });

  const hasAddedOptions = !isEmpty(addedOptions);

  if (customerMTAOptions.allow_option_removal?.enabled && hasAddedOptions) {
    return (
      <>
        <MTAChangeDetails
          text={'Remove Additional Cover'}
          icon={'cycle.svg'}
          handleClick={handleSelection}
        />
      </>
    )
  }
  return null;

}
